import { render, staticRenderFns } from "./list.vue?vue&type=template&id=899b60da&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=899b60da&prod&scoped=true&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=899b60da&prod&scoped=true&lang=scss"
import style2 from "./list.vue?vue&type=style&index=2&id=899b60da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b60da",
  null
  
)

export default component.exports